import React from "react";
import about from "../assets/Hero/about.jpeg";

export const About = (props) => {
  return (
    <div id="about" className="about-section">
      <div className="container">
        <div className="row about-container">
          <div className="col-xs-12 col-md-12 h3 mb-5 mt-5">
            <h2>About Us</h2>
          </div>
        </div>
        <div className="row about-container">
          <div className="col-xs-12 col-md-6 about-image">
            <img src={about} className="img-responsive" alt="About Us" />
          </div>
          <div className="col-xs-12 col-md-6 about-content">
            <div className="about-text">
              <p>{props.data ? props.data.paragraph : "Loading..."}</p>
              <h4>Why Choose Us?</h4>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6">
                  <ul>
                    {props.data?.Why?.map((d, i) => (
                      <li key={`${d}-${i}`}>{d}</li>
                    )) || "Loading..."}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6">
                  <ul>
                    {props.data?.Why2?.map((d, i) => (
                      <li key={`${d}-${i}`}>{d}</li>
                    )) || "Loading..."}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
